import React from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import Form from "../../common/Form";
import Row from "../../common/Row";
import NumberInput from "../../common/NumberInput";
import TextInput from "../../common/TextInput";
import DownloadUploadFile from "../../common/DownloadUploadFiles";
import { getFilesForDossierComponent } from "../../common/DownloadUploadFilesHelper.js";
import Fieldset from "../../common/Fieldset";
import * as domainConstants from '../../../constants/DomainConstants';
import FinancieelTableComponent from "../parts/FinancieelTableComponent";
import Button from "../../common/Button";
import * as types from "../../../constants/ComponentConstants";
import { Popup } from 'semantic-ui-react';
import moment from "moment";

const FinancieringForm = (props) => {
    const {
        model,
        color,
        disabled,
        showDeleteModal,
        documenten,
        getFileUrl,
        generateRapport,
        isPollingDocument,
        goToFinancierEdit,
        handleOnEditFinancier
    } = props;

    function mapOnShowDeleteModal(id) {
        return function (event) {
            showDeleteModal(event, id);
        };
    }

    function mapOnEditFinancier(dossierId, financierId) {
        return function (event) {
            handleOnEditFinancier(dossierId, financierId);
        };
    }

    const isIngediend = model.redenVanStatus.toString() === domainConstants.REDEN_VAN_STATUS_INGEDIEND;
    const noModelsContent = "Je hebt nog geen financiers ingegeven.";

    const tableSettings = {
        tableHeaders: ["FINANCIER", "AANDEEL €", "AANDEEL %", "BEWIJS", ""],
        tableHeaderSizes: [3, 1, 1, 1, 1],
        noModelsContent: noModelsContent,
        hasRows: model.financiers.length > 0,
        tableRows: model.financiers.map((financier, i) => {
            const heeftBewijsVanFinanciering = financier.ulBewijsVanFinanciering.aantal > 0;
            const tdStyle = financier.volledig ? null : { color: 'orange' };
            const fileUrl = heeftBewijsVanFinanciering ? getFileUrl(model.dossierId, financier.id, financier.ulBewijsVanFinanciering.documenten) : null;

            return (<tr key={"financier_" + i}>
                <td style={tdStyle}>{financier.naam ? financier.naam : null}</td>
                <td style={tdStyle}>{financier.aandeelInBedrag != null ? "€ " + financier.aandeelInBedrag.toLocaleString('nl-BE') : ""}</td>
                <td style={tdStyle} >{(financier.aandeelInPercent != null ? financier.aandeelInPercent.toFixed(2) : "") + " %"}</td>
                <td>{heeftBewijsVanFinanciering ? <a href={fileUrl} style={{ fontSize: '1.2rem' }}><i className="fa fa-file-text-o fa-fw"/></a> : null}</td>
                <td>
                    {isIngediend ? null : <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-trash fa-fw" onClick={mapOnShowDeleteModal(financier.id)} />} content="verwijder financier" /></span>}
                    <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-pencil fa-fw" onClick={mapOnEditFinancier(model.dossierId, financier.id)} />} content="wijzig financier" /></span>                </td>
            </tr >);
        })
    };

    let totaalGedragenDoorDeFinanciers = 0;
    let totaalGedragenDoorDeFinanciersResultClassName = "fa " + types.TOOLTIP_ICON_EXCLAMATION;
    let totaalGedragenDoorDeFinanciersResultTooltipText = "onvoldoende financiering";
    let totaalGedragenDoorDeFinanciersResultStyle = { color: "red", "fontSize": "3em" };
    if (model.financiers)
        model.financiers.filter(f => f.aandeelInBedrag).forEach(f => totaalGedragenDoorDeFinanciers += parseFloat(f.aandeelInBedrag));
    if (totaalGedragenDoorDeFinanciers >= model.totaalTeDragenDoorDeFinanciers) {
        totaalGedragenDoorDeFinanciersResultClassName = "fa " + types.TOOLTIP_ICON_CHECK;
        totaalGedragenDoorDeFinanciersResultStyle.color = "green";
        totaalGedragenDoorDeFinanciersResultTooltipText = "voldoende financiering";
    }

    const icon = <i className={totaalGedragenDoorDeFinanciersResultClassName} style={totaalGedragenDoorDeFinanciersResultStyle}/>;

    return (<Section title={domainConstants.FinancieelTitels.FinancieleHaalbaarheid} color={color}>
        <Form
            title="Financiering"
            name="financiering"
            isNotRequired>

            <Fieldset title="Totale investeringskost">
                <Row>
                    <NumberInput
                        name="totaalSportgerelateerdeInvestering"
                        label="Totaal te financieren bedrag"
                        value={model.totaleInvestering}
                        disabled
                        isValuta
                        size={3}
                        hasLongLabelInRow
                        onChange={() => { }} />
                    <NumberInput
                        name="aandeelVlaanderen"
                        label="Aandeel Vlaanderen"
                        value={model.aandeelVlaanderen}
                        disabled
                        isValuta
                        size={3}
                        hasLongLabelInRow
                        onChange={() => { }} />
                    <TextInput
                        name="aandeelVlaanderenInPercent"
                        label="Aandeel Vlaanderen in percent"
                        value={model.aandeelVlaanderenInPercent + " %"}
                        disabled
                        size={3}
                        onChange={() => { }} />
                    <NumberInput
                        name="totaalTeDragenDoorDeFinanciers"
                        label="Totaal te dragen door de financiers"
                        value={model.totaalTeDragenDoorDeFinanciers}
                        disabled
                        isValuta
                        size={3}
                        hasLongLabelInRow
                        onChange={() => { }} />
                </Row>
            </Fieldset>
            <Fieldset title="Financiers">
                <FinancieelTableComponent
                    settings={tableSettings}
                    disabled={disabled} />
                {isIngediend ? null : <Button text="Voeg financier toe" onClick={goToFinancierEdit} />}
                < br /> <br />
                <Row>
                    <NumberInput
                        name="totaalTeDragenDoorDeFinanciersResult"
                        label="Totaal Te dragen door de financiers"
                        value={model.totaalTeDragenDoorDeFinanciers}
                        disabled
                        isValuta
                        size={3}
                        onChange={() => { }} />
                    <NumberInput
                        name="totaalGedragenDoorDeFinanciersResult"
                        label="Totaal gedragen door de financiers"
                        value={totaalGedragenDoorDeFinanciers}
                        disabled
                        isValuta
                        size={3}
                        onChange={() => { }} />

                    <Popup trigger={icon} content={totaalGedragenDoorDeFinanciersResultTooltipText} />

                </Row>
            </Fieldset>
            <Fieldset title="Rapport financiële haalbaarheid">
                <Row>
                    <DownloadUploadFile
                        dossierId={model.dossierId}
                        title="Rapporten"
                        size={6}
                        tab={domainConstants.DocumentTab.MinimaleEisen}
                        component={domainConstants.ComponentName.HaalbaarheidsRapport}
                        files={getFilesForDossierComponent(domainConstants.ComponentName.HaalbaarheidsRapport, documenten)}
                        color={color}
                        defaultText="Nog geen documenten beschikbaar"
                        downloadOnly />

                    <div className="o-col-6" style={{ paddingTop: '15px' }}>
                        <Button onClick={generateRapport} disabled={isPollingDocument || disabled}>Genereer rapport</Button>
                        {isPollingDocument ? <p>Even wachten aub</p> : ""}

                    </div>
                </Row>
                <Row>
                    {model.datumFinancieleHaalbaarheidRapportGeneratie ? <p>Documenten gegenereerd op: {moment(model.datumFinancieleHaalbaarheidRapportGeneratie).format("DD-MM-YYYY HH:mm")}</p> : ""}
                </Row>
            </Fieldset>
        </Form>
    </Section>);
};

FinancieringForm.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    model: PropTypes.object,
    goToFinancierEdit: PropTypes.func,
    getFinancierEditUrl: PropTypes.func,
    showDeleteModal: PropTypes.func,
    documenten: PropTypes.array,
    generateRapport: PropTypes.func,
    getFileUrl: PropTypes.func,
    isPollingDocument: PropTypes.bool,
    deleteFinancier: PropTypes.func,
    handleOnEditFinancier: PropTypes.func
};

export default FinancieringForm;